<template>
  <div class="locale-selector d-inline-block vertical-align-middle ml-2">
    <v-select
      v-model="locale"
      :items="locales"
      density="comfortable"
      variant="solo"
      color="white"
      item-color="white"
      hide-details
      bg-color="transparent"
      flat
      menu-icon="fa-caret-down"
      :list-props="{ bgColor: '#161C30' }"
    >
      <template #selection="{ item }">
        <country-flag
          :country="item.title"
          rounded
          size="normal"
        />
      </template>
      <template #item="{ item }">
        <v-list-item
          link
          @click="locale = item"
          class="locale-list-item"
        >
          <country-flag
            :country="item.title"
            rounded
            size="normal"
          />
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag-next';
import { useAuthStore } from '@/store/auth.module';
import { useI18n } from 'vue-i18n';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'LocaleSelector',
  components: {
    CountryFlag,
  },
  data() {
    return {
      locales: [
        {
          title: 'gb',
          value: 'en',
        },
        {
          title: 'fr',
          value: 'fr',
        },
        {
          title: 'es',
          value: 'es',
        },
      ],
    };
  },
  computed: {
    locale: {
      get() {
        const authStore = useAuthStore();
        return this.locales.find((locale) => locale.value === authStore.getLocale)
      },
      set(locale) {
        const authStore = useAuthStore();
        authStore.setLocale(locale.value);
        this.$i18n.locale = locale.value;
      },
    },
  },
};
</script>

<style>
.locale-selector {
  width: 105px;
  height: 40px;
}

.locale-list-item {
  text-align: center;
}

</style>
